import React from "react";

import SoftBox from "../../../../components/SoftBox";
import SoftTypography from "../../../../components/SoftTypography";

import { useGetCredentials } from "../../hooks";
import DataTable from "../../../../examples/Tables/DataTable";
import NewCredentialsModal from "../../components/NewCredentialsModal";
import DeleteCredentialModal from "../../components/DeleteCredentialModal";

const Credentials = () => {
  const { data: credentials, isLoading } = useGetCredentials();

  const getRows = () => {
    return _.map(credentials, (item) => ({
      id: item._id,
      name: item.destinationName,
      action: <DeleteCredentialModal id={item._id} />,
    }));
  };

  return (
    <SoftBox>
      <SoftBox display="flex" justifyContent="flex-end" px={{ xs: 2, sm: 2.875 }} pt={3} pb={2}>
        <NewCredentialsModal />
      </SoftBox>
      <SoftBox>
        {credentials?.length > 0 ? (
          <DataTable
            embedded
            table={{
              columns: [
                { Header: "ID", accessor: "id" },
                { Header: "Name", accessor: "name" },
                { Header: "Action", accessor: "action" },
              ],
              rows: getRows(),
            }}
            manualPagination={false}
            isLoading={isLoading}
            columnsFilter={true}
            isClickable={true}
            showTotalEntries={false}
            canSearch={false}
            entriesPerPage={false}
            //   onCellClick={onCellClick}
          />
        ) : (
          <SoftBox display="flex" justifyContent="center" alignItems="center" height="100%" p={3}>
            <SoftTypography variant="h6" fontWeight="medium" textTransform="capitalize">
              No credentials found
            </SoftTypography>
          </SoftBox>
        )}
      </SoftBox>
    </SoftBox>
  );
};

export default Credentials;
